<template>
  <div>
    <div :class="{'main-container':!showHistoryPopup}" style="margin-bottom: 20px !important;">
      <breadcrumb v-if="!showHistoryPopup" :list="breadcrumbList" />
      <tl-tabs
        v-if="!showHistoryPopup"
        :tabs="tabs"
        ref="activeIndex"
        @changeTab="parentTabChange"
        :customclass="true"
        class="margintop-20"
      >
        <tl-tab>
          <revise-salary v-if="empreviseSalary" ref="salaryRevision" @swichTab="changingTab" />
        </tl-tab>
        <tl-tab>
          <revise-salary-list
            @reviseSalary="goTorevisepage"
            @swichTab="changingTab"
            ref="reviseList"
            @historyCheck="goToHistoryPage"
          />
        </tl-tab>
        <tl-tab>
          <revise-salary-deletion v-if="reviseSalaryDeletion" @swichTab="changingTab" />
        </tl-tab>
      </tl-tabs>
      <history-page
        v-if="showHistoryPopup"
        @hideHistoryPage="hideHistory"
        :employeeDetails="employeeDetails"
      />
    </div>
    <div class="table-class">
      <div style="margin-left: 50px;">
        <button class="refresh" @click="refreshData">Refresh</button>

      <tl-header type="h3" class="title">
            Progress List
    </tl-header>
    <data-table
    style="margin-bottom: 20px;"
            :columns="heading" 
            :tableData="progressStatus"                 
            :checkbox="false"
            :withForm="false"
            :showinrow="false"
            :showhistory="false"
            class="custom-data"
          >
          </data-table>
    </div>
    <!-- <div style="max-width: 40%;">
      <tl-header type="h3" class="title">
            Completed Lists
    </tl-header>
    <data-table
            :columns="heading"                  
            :tableData="completed.slice(0,6)"  
            :checkbox="false"
            :withForm="false"
            :showinrow="false"
            :showhistory="false"
            class="custom-data"
          >
          <template v-slot:rowcontent="slotprops">
            <div class="complete-bar"  v-if="slotprops.value.column.key === 'progress'">
              <progress max="100" :value= "slotprops.value.record.progress" style="appearance: none;"></progress>
              {{ slotprops.value.record.progress}}%
        </div>
      </template>
          </data-table>
    </div> -->
  </div>
  </div>
</template>
<script>
import Breadcrumb from "@/components/BreadCrumb.vue";
import reviseSalary from "./revise.vue";
import revisionSalary from "./revisionSalary.vue";
import HistoryPage from "./historyPage.vue";
import reviseSalaryList from "./reviseSalaryList.vue";
import { mapState, mapActions,mapGetters } from "vuex";
import reviseSalaryDeletion from "./reviseSalaryDeletion.vue";
export default {
  components: {
    Breadcrumb,
    reviseSalary,
    revisionSalary,
    HistoryPage,
    reviseSalaryList,
    reviseSalaryDeletion
  },
  data() {
    return {
      heading:[
    { label: "Name", key: "name" },
    { label: "Email", key: "email" },

    { label: "Status", key: "status" }, 
  ],
      tabs: [
        {
          header: "Scheduled"
        },
        {
          header: "History"
        },
        {
          header: "Bulk Deletion"
        }
      ],
      breadcrumbList: [
        {
          name: "Payroll",
          url: `/dashboard/${this.$route.params.entity_index}/payroll`
        },
        {
          name: "Utilities",
          url: `/dashboard/${this.$route.params.entity_index}/payroll/utilities`
        },
        {
          name: "Salary Revision",
          url: `/dashboard/${this.$route.params.entity_index}/payroll/utilities/revise_salary`
        }
      ],
      showHistoryPopup: false,
      showRevisedSalary: true,
      empreviseSalary: true,
      employeeDetails: {},
      progressStatus:[],
      socket: null,
      actives: [],
      completed: [],
      reviseSalaryDeletion: false,
    
    };
  },

  
  
  computed: {
    ...mapState({
      entities: state => state.onboard.legal_entities.data
      
    }),
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID",

    }),
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    },
  },
  mounted(){
//     this.socket = new WebSocket(process.env.VUE_APP_WEBSOCKET_SALARY);
//       this.socket.addEventListener('open', (event) => {
//         console.log('WebSocket connection opened');
//     });
//     this.socket.addEventListener('message', (event) => {
//       let dataArray = JSON.parse(event.data);
//       let completed = [] 
//       this.entities.filter(item => {
//     let result = dataArray.find(x => {
//         return x.data.legal_entity_id == item.id;
//     });
//     if (result && result.progress == 100) {
//       let timestamp = new Date(result.timestamp);
//         let formattedTimestamp = timestamp.toLocaleDateString('en-GB');
//       let completedItem = {
//          timestamp : formattedTimestamp,
//          progress : result.progress,
//          email : result.data.email,
//          filename : result.data.legal_entity_name,
//          status : result.progress === 100 ? 'Completed' : 'Pending',
//         };
//         completed.push(completedItem);
//     }
// });
//       let actives = []
//       this.entities.filter(item => {
//         let result = dataArray.find(x => {
//         return x.data.legal_enitity_id == item.id;
//     });
//         if(result && result.progress < 100){
//           let timestamp = new Date(result.timestamp);
//         let formattedTimestamp = timestamp.toLocaleDateString('en-GB');
//         let activeItem = {
//          timestamp : formattedTimestamp,
//          progress : result.progress,
//          email : result.data.email,
//          filename : result.data.email,
//          status : result.progress === 100 ? 'Completed' : 'Pending',
//         };
//         actives.push(activeItem)
//         }
        
//       })
     
//       this.actives = actives;
//       this.completed = completed
//       if(event.data == null){
//         this.socket.addEventListener('close', (event) => {
//         console.log('WebSocket connection closed');
//       });
//       }
//     });
},
created(){
// this.getSalaryRevision()
},
methods: {
    ...mapActions({
      act_fetch_salary_revision: "globalapi/globalemployees/fetchSalaryRevisionData",

    }),
    editRevisedSalary(val) {
      this.showRevisedSalary = true;
    },
    historyPage(record) {
      this.showHistoryPopup = true;
    },
    refreshData(){
      console.log('clicked')
      this.getSalaryRevision()
    },
    hideHistory() {
      this.showHistoryPopup = false;
    },
    parentTabChange(tabIndex) {
      if(tabIndex == 0) {
        this.empreviseSalary = true;
      }
      this.active_selected_index = tabIndex;
      if (!this.$refs.active_selected_index) {
        this.$refs.salaryRevision.showCtcDetailsCard = false;
        this.$refs.salaryRevision.masterSalaryData = [];
      }
      if(tabIndex == 2) {
        this.reviseSalaryDeletion = true;
        this.empreviseSalary = false;
      }
    },
    goTorevisepage(record) {
      if (record) {
        this.$refs.salaryRevision.selectedEmp(record);
      } else {
        this.$refs.salaryRevision.showCtcDetailsCard = false;
      }
      this.empreviseSalary = true;
    },
    changingTab(value, record) {
      if (value == 1) {
        this.$refs.reviseList.fetchEmplDetails();
        this.$refs.reviseList.toast = false;
      } else {
        this.goTorevisepage(record);
      }
      this.$refs.activeIndex.active_selected_index = value;
    },
    goToHistoryPage(record) {
      this.employeeDetails = record;
      this.showHistoryPopup = true;
    },
   
    async getSalaryRevision() {
      try {
      console.log('hey')
        let res = await this.act_fetch_salary_revision({
          data:{le_id: this.le_id, page: 2, limit: 10 }
        });
       console.log(res.data,'res')
       this.progressStatus = res.data.payload.map((item) => ({
        name: item.name,
        email: item.email,
        status: item.status,
      }));
      console.log(this.progressStatus ,'this.progressStatus ')
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    goToPayroll() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll`
      });
    },
    goToUtilities() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/utilities`
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.table-class{
// display: grid; 
// grid-template-columns: repeat(2, 1fr);
padding: 20px;
gap: 20px; 
font-size: 12px; 
width: 100%; 
overflow: auto;
}
.active-bar > progress::-webkit-progress-value{
  background-color: #2780fd;
  border-radius: 10px;
}

progress::-webkit-progress-bar{
  background-color: #e2e2e2;
  border-radius: 10px;
}
.refresh{
  background-color: #5d409f;
  color: #ffffff;
  font-weight: 500;
  border-radius: 4px;
  padding: 8px 18px;
  margin-bottom: 30px;
  transition: all 0.5s ease;
}

.refresh:hover{
  opacity: 0.8;
}

.complete-bar > progress::-webkit-progress-value{
  background-color: #00b430;
  border-radius: 10px !important;
}
::v-deep .custom-data td{
  padding: 10px !important;
}

</style>
